import { MapDispatchToPropsFunction } from 'react-redux'
import { State } from 'interfaces/state'
import { selectRelationActionCreator, randomizePeergroupRelationActionCreator, requestDeleteRelationActionCreator } from 'actions/peergroupActions'
import {
  hidePeergroupPopupActionCreator,
  setShownSidebarPaneActionCreator,
  editRelationActionCreator,
  registerPeergroupPopupTimeoutActionCreator,
} from 'actions/sidebarActions'
import { createRelationSelector, createPeergroupByRelationSelector, peergroupPopupTimeoutIdSelector, isRandomizingSelector } from 'selectors/peergroupSelectors'
import { connectOptionally, createPositiveRendererProps, NO_RENDER, OptionalRendererProps } from 'tangle-shared'
import { viewportSegmentSelector } from 'selectors/viewportSelectors'
import {
  SidebarPeergroupPopup,
  SidebarPeergroupPopupStateProps,
  SidebarPeergroupPopupDispatchProps,
  SidebarPeergroupPopupOwnProps,
} from 'components/features/pfm/SidebarPopup/SidebarPeergroupPopup'

const popupRelationSelector = createRelationSelector()
const popupPeergroupSelector = createPeergroupByRelationSelector()

const mapStateToProps = (state: State, ownProps: SidebarPeergroupPopupOwnProps): OptionalRendererProps<SidebarPeergroupPopupStateProps> => {
  const relation = popupRelationSelector(state, ownProps)
  const peergroup = popupPeergroupSelector(state, ownProps)

  if (!relation || !peergroup) {
    return NO_RENDER()
  }

  return createPositiveRendererProps({
    relation,
    peergroup,
    viewportSegment: viewportSegmentSelector(state),
    hideTimeoutId: peergroupPopupTimeoutIdSelector(state),
    isRandomizing: isRandomizingSelector(state),
  })
}

const mapDispatchToProps: MapDispatchToPropsFunction<
  SidebarPeergroupPopupDispatchProps,
  SidebarPeergroupPopupOwnProps
> = (dispatch, ownProps) => ({
  onSelectRelation: () => {
    dispatch(selectRelationActionCreator(ownProps.relationId))
    dispatch(hidePeergroupPopupActionCreator(ownProps.relationId))
    dispatch(setShownSidebarPaneActionCreator(null))
  },
  onEdit: () => dispatch(editRelationActionCreator(ownProps.relationId)),
  onRemove: () => dispatch(requestDeleteRelationActionCreator(ownProps.relationId)),
  onRandomize: () => dispatch(randomizePeergroupRelationActionCreator()),
  onHidePopup: () => dispatch(hidePeergroupPopupActionCreator(ownProps.relationId)),
  onRegisterHideTimeout: (timeoutId) => dispatch(registerPeergroupPopupTimeoutActionCreator(timeoutId)),
})

export const PeergroupMenuPopupContainer = connectOptionally<
  SidebarPeergroupPopupStateProps,
  SidebarPeergroupPopupDispatchProps,
  SidebarPeergroupPopupOwnProps
>(mapStateToProps, mapDispatchToProps)(SidebarPeergroupPopup)
